/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ where: NonNullable<unknown> }} Cmspost_Error_Linked1Inputs */

const vi_cmspost_error_linked1 = /** @type {(inputs: Cmspost_Error_Linked1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bài đang được liên kết ở: ${i?.where}. Đổi hoặc bỏ liên kết đó trước rồi mới gỡ / xoá / đổi đường dẫn bài.`)
};

/**

* @param {Cmspost_Error_Linked1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_linked1 = /** @type {((inputs: Cmspost_Error_Linked1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Linked1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_linked1(inputs)
});
export { cmspost_error_linked1 as "cmsPost_error_linked" }